export default defineNuxtPlugin(nuxtApp => {
	function populatedInput(event) {
		let theThingParent = event.target.parentElement;
		theThingParent.classList.add('populated')
	}
	return {
		provide: { populatedInput }
	}
})
